import instance from '../axios'

const showsApi = {
    getTrending: (page: number = 1) => {
        return instance.get(`/shows/trending`, { params: { page } })
    },

    getPopular: (page: number = 1) => {
        return instance.get(`/shows/popular`, { params: { page } })
    },

    getTopRated: (page: number = 1) => {
        return instance.get(`/shows/top-rated`, { params: { page } })
    },

    getAiringToday: (page: number = 1) => {
        return instance.get(`/shows/airing-today`, { params: { page } })
    },

    getOnTheAir: (page: number = 1) => {
        return instance.get(`/shows/on-the-air`, { params: { page } })
    },

    getMarvel: (page: number = 1) => {
        return instance.get(`/shows/marvel`, { params: { page } })
    },

    getNetflix: (page: number = 1) => {
        return instance.get(`/shows/netflix`, { params: { page } })
    },

    getByNetwork: (networkKey: string, page: number = 1) => {
        return instance.get(`/shows/network/${networkKey}`, { params: { page } })
    },

    getByProvider: (providerKey: string, page: number = 1) => {
        return instance.get(`/shows/provider/${providerKey}`, { params: { page } })
    },

    getSeason: (showId: number, seasonNumber: number) => {
        return instance.get(`/shows/${showId}/season/${seasonNumber}`)
    },

    search: (query: string, page: number = 1) => {
        return instance.get(`/shows/search`, { params: { query, page } })
    },

    getById: (id: number) => {
        return instance.get(`/shows/${id}`)
    },

    getRecommendations: (id: number, page: number = 1) => {
        return instance.get(`/shows/${id}/recommendations`, { params: { page } })
    }
}

export default showsApi
